var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSelector } from 'reselect';
// eslint-disable-next-line @typescript-eslint/prefer-optional-chain
var getCountries = function (state) { return state.countries && state.countries.countries; };
// eslint-disable-next-line @typescript-eslint/prefer-optional-chain
var getCountryCode = function (state) { return state.event && state.event.address && state.event.address.countryCode; };
export var getCountryName = createSelector(getCountries, getCountryCode, function (state, translate) { return translate; }, function (countries, countryCode, translate) {
    return countries && countryCode ? translate(countries[countryCode].nameResourceKey) : undefined;
});
export var getAddressWithCountryName = createSelector(function (state) { return state.event.address; }, getCountryName, function (address, countryName) {
    return __assign(__assign({}, address), { countryName: countryName });
});
